import {
  type ReactNode,
  createContext,
  useCallback,
  useContext,
  useState
} from 'react'

interface CeoContextValue {
  open: boolean
  setOpen: (v: boolean) => void
  toggle: () => void
  /** Page-context that gets shipped with each user message. */
  currentPage: string
  setCurrentPage: (v: string) => void
}

const CeoContext = createContext<CeoContextValue | null>(null)

export function CeoProvider({ children }: { children: ReactNode }) {
  const [open, setOpen] = useState(false)
  const [currentPage, setCurrentPage] = useState<string>('')

  const toggle = useCallback(() => setOpen((v) => !v), [])

  return (
    <CeoContext.Provider
      value={{ open, setOpen, toggle, currentPage, setCurrentPage }}
    >
      {children}
    </CeoContext.Provider>
  )
}

export function useCeo(): CeoContextValue {
  const ctx = useContext(CeoContext)
  if (!ctx) throw new Error('useCeo must be used inside <CeoProvider>')
  return ctx
}
